// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
function ConvertEntityNotification(props: any) {
  return null;
}

export default ConvertEntityNotification;
